//Local Storage
//import AsyncStorage from '@react-native-async-storage/async-storage';

//Types
import { 
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    OBTENER_USUARIO,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    LIMPIAR_ERROR,
    MENSAJE_LICENCIA,
    SET_LINKS_APP,
    SIGNUP_EXITOSO,
    SIGNUP_ERROR,
    CONFIRM_EMAIL_EXITOSO,
    CONFIRM_EMAIL_ERROR,
    SEND_EMAIL_TO_RECOVER_PASSWORD_EXITOSO,
    SEND_EMAIL_TO_RECOVER_PASSWORD_ERROR,
    VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_EXITOSO,
    VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_ERROR,
    OVERWRITE_PASSWORD_EXITOSO,
    OVERWRITE_PASSWORD_ERROR,
    NOT_SHOW_TUTO,
    OBTENER_USUARIO_CHANGE_PASSWORD,
    UPDATE_COLUMNS_PREFERENCES_USUARIO,
    UPDATE_AUTOBLOQUEO_USUARIO,
    SET_DICTIONARY,
    SET_GLOBALSETTINGS,
} from "./authActions";

const authReducer = (state, action) => {
    switch(action.type){

        case LOGIN_EXITOSO:
        case REGISTRO_EXITOSO:
             //AsyncStorage.setItem('token', action.payload.token);

            return{
                ...state,
                autenticado: true, 
                token:action.payload.token,
                mensaje: null,
                cargando: false
            }
            
        case CERRAR_SESION:
            return{
                ...state,
                token: null,
                autenticado: false,
                usuario: null,
                cargando:false,
                mensaje: action.payload
            }
        case LOGIN_ERROR:
            return{
                ...state,
                mensaje: action.payload.msg
            }
        case REGISTRO_ERROR:
            //AsyncStorage.removeItem('token');
            return{
                ...state,
                token: null,
                mensaje: action.payload.msg,
                autenticado: false,
                usuario: null,
                cargando:false
            }

        case LIMPIAR_ERROR:{
            return{
                ...state,
                token: null,
                mensaje: null,
                autenticado: false,
                usuario: null,
                cargando:false
            }
        }
        
        case OBTENER_USUARIO:
            return {
                ...state,
                usuario: action.payload,
                showTuto: action.payload.showTuto,
                autenticado: true,
                cargando:false
            }
        case OBTENER_USUARIO_CHANGE_PASSWORD:
            return {
                ...state,
                autenticado:false,
                usuario: action.payload,
            }
        
        case NOT_SHOW_TUTO:
            return{
                ...state,
                showTuto: false
            }

        //Se aprovecha para setear los links a las Apps Mobiles y confirmar si posee o no un Web Service configurado.
        case SET_LINKS_APP:
            return {
                ...state,
                dictionary: action.payload.dictionary,
                globalSettings: action.payload.globalSettings,
                hasWebServiceConfigured: action.payload.hasWebServiceConfigured
            }

        case SET_GLOBALSETTINGS:
            return {
                ...state,
                globalSettings: action.payload,
            }
        // case SET_DICTIONARY:
        //     return {
        //         ...state,
        //         dictionary: action.payload,
        //         globalSettings: action.payload,
        //     }

        case MENSAJE_LICENCIA:
            return {
                ...state,
                mensajeLicencia: action.payload
            }

        //Creados recientemente para Prueba Gratuita
        case SIGNUP_EXITOSO:
            return{
                ...state,
                token: null,
            }
        case CONFIRM_EMAIL_EXITOSO:
            return{
                ...state,
                token: null,
            }
        case SEND_EMAIL_TO_RECOVER_PASSWORD_EXITOSO:
            return{
                ...state,
                token: null,
            }
        case OVERWRITE_PASSWORD_EXITOSO:
            return{
                ...state,
                token: null,
            }
        case VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_EXITOSO:
            return{
                ...state,
                token: null,
            }
        case SIGNUP_ERROR:
            return{
                ...state,
                mensaje: action.payload.msg
            }
        case CONFIRM_EMAIL_ERROR:
            return{
                ...state,
                mensaje: action.payload.msg
            }
        case SEND_EMAIL_TO_RECOVER_PASSWORD_ERROR:
            return{
                ...state,
                mensaje: action.payload.msg
            }
        case OVERWRITE_PASSWORD_ERROR:
            return{
                ...state,
                mensaje: action.payload.msg
            }
        case VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_ERROR:
            return{
                ...state,
                mensaje: action.payload.msg
            }
        //Fin Creados Recientemente

        case UPDATE_COLUMNS_PREFERENCES_USUARIO:{
            return {
                ...state,
                usuario: {...state.usuario, columnsPreferences: action.payload}
            }
        }

        case UPDATE_AUTOBLOQUEO_USUARIO:{
            return {
                ...state,
                usuario: {...state.usuario, autobloqueoReservas: action.payload}
            }
        }

        default:
            return state;
    }
}

export default authReducer;